import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const CONSENT_KEY = "islasol_consent";
export const getConsent = () => localStorage.getItem(CONSENT_KEY) || "";
export const hasAnalyticsConsent = () => getConsent() === "all";

let loaded = false;
const loadGa = (id) => {
  if (loaded || !id) return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true, send_page_view: false });
  const s = document.createElement("script");
  s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(s);
};

/** Lädt Google Analytics 4 nur bei erteilter Einwilligung und meldet Seitenaufrufe bei Routenwechsel. */
export const Analytics = ({ measurementId }) => {
  const loc = useLocation();
  useEffect(() => {
    const on = () => { if (measurementId && hasAnalyticsConsent()) loadGa(measurementId); };
    on();
    window.addEventListener("islasol-consent", on);
    return () => window.removeEventListener("islasol-consent", on);
  }, [measurementId]);
  useEffect(() => {
    if (measurementId && hasAnalyticsConsent() && window.gtag) {
      window.gtag("event", "page_view", { page_path: loc.pathname + loc.search, page_location: window.location.href, page_title: document.title });
    }
  }, [loc.pathname, loc.search, measurementId]);
  return null;
};
